import { Button, CommonSelect, Text, TextSize, Weight } from 'components'
import styled from 'styled-components'
import { GLOBAL_COLORS } from 'theme'
import { Flex } from '../../base/flex/index'

export const Wrapper = styled.div`
  ${({ theme }) => theme.mediaWidth.Mobile`
  margin-top: 20px;`}
`

export const ProductChartAreaWrapper = styled.div``

export const WrapperInterval = styled.div`
  display: flex;
  gap: 20px;
  height: 40px;
  padding: 20px 0;
  margin-right: 0px;
  align-items: center;
  ${({ theme }) => theme.mediaWidth.Mobile`
    flex-direction: column;
    border: 1px solid ${theme.text1};
    border-radius: 10px;
    width: 140px;
    height: 120px;
    padding: 0;
`}
`

export const FooterWrapper = styled(Flex)`
  width: 100%;
  ${({ theme }) => theme.mediaWidth.Mobile`
    justify-content: center;
`}
  ${({ theme }) => theme.mediaWidth.Tablet`
    justify-content: center;
`}
`

export const ChartHeater = styled.div<{ isPortfolio: boolean; plateFormate: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 5px 0;
  gap: 20px;
  position: relative;
  ${({ isPortfolio, plateFormate }) =>
    isPortfolio &&
    `
      background: ${GLOBAL_COLORS.lightBlue05};
      border-radius: 10px;
      justify-content: ${plateFormate ? 'space-between' : 'flex-start'};
      padding: 20px;
      max-width: 100%;
      width: fill-available;
    `};

  ${({ theme }) => theme.mediaWidth.Mobile`
    width: 100%;
  `}
  ${({ theme }) => theme.mediaWidth.Tablet`
    width: 100%;
  `}
`

export const HeatWrapper = styled.div<{ isPortfolio?: boolean; withButton?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${({ theme, withButton }) => theme.mediaWidth.Desktop`
    flex-direction: row;
    ${
      withButton &&
      `
      justify-content: space-between;
      margin-left: 50px;
      width: fill-available;
    `
    };
  `}
  ${({ theme, isPortfolio }) => theme.mediaWidth.Tablet`
    ${
      !isPortfolio &&
      `
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    `
    };
  `}
  ${({ theme, isPortfolio }) => theme.mediaWidth.Mobile`
    ${
      !isPortfolio &&
      `
      flex-direction: row; 
      display: flex !important;
      width: 100%;
    `
    };
  `}
`
export const HeaterStatistic = styled.div<{ fullWidth?: boolean }>`
  min-width: ${({ fullWidth }) => (fullWidth ? 'fit-content' : '60px')};
  display: flex;
  flex-direction: column;
`

export const ColoredContainer = styled.div<{ color: string }>`
  height: 20px;
  width: 5px;
  border-radius: 4px;
  background: ${({ color }) => color};
`

export const CustomChangeWrapper = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  min-width: 180px;
  ${({ theme }) => theme.mediaWidth.Mobile`
  min-width: 160px;
`}
`

export const TimeIntervals = styled(Text)<{ active?: boolean; isPortfolio?: boolean }>`
  margin: 0px;
  transition: 0.5s;
  cursor: pointer;
  font-weight: ${(props) => (props.active ? Weight.ExtraBold : Weight.Regular)};
  font-size: ${TextSize.small};
  min-width: 55px;
  display: inline-flex;
  justify-content: center;
  ${({ theme, isPortfolio }) => theme.mediaWidth.Desktop`
    ${!isPortfolio && `font-size: ${TextSize.small};`}
  `}
  &:hover {
    font-weight: ${Weight.ExtraBold};
  }
`

export const CustomText = styled(Text)`
  color: ${({ theme }) => theme.whiteToCoreGrey};
  margin: 0;
  margin-bottom: 5px;
  display: flex;
  min-width: fit-content;
`

export const CustomTextHeader = styled(Text)`
  color: ${({ theme }) => theme.whiteToCoreGrey};
  margin: 0;
  margin-bottom: 5px;
  display: flex;
`

export const StyledDetailsText = styled(Text)`
  font-weight: ${Weight.SemiBold};
`

export const ButtonBuySell = styled(Button)`
  display: flex;
  width: 140px;
  height: 40px;
  ${({ theme }) => theme.mediaWidth.Desktop`
    align-self: flex-end;
  `}
`

export const StyledHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  position: relative;
  ${({ theme }) => theme.mediaWidth.Mobile`
  width: 100%;
`}
  ${({ theme }) => theme.mediaWidth.Tablet`
  width: 100%;
`}
`
export const StyledSelect = styled(CommonSelect)`
  position: absolute;
  top: -54px;
  right: 0;
`
